import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConfirmBatchStampComponent } from './confirm-batch-stamp/confirm-batch-stamp.component';

@Injectable()
export class ConfirmBatchStampService {
  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
  ) { }

  confirm(title: string, message: string, options: string[]): Observable<string> {
    const initialState = {
      title: title,
      message: message,
      answer: false,
      options: options,
    };
    this.bsModalRef = this.bsModalService.show(ConfirmBatchStampComponent, { initialState });

    return new Observable<string>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        observer.next(this.bsModalRef.content.answer);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/confirm-batch-stamp.service.ts